import React from "react"
import classNames from "classnames"
import styles from "./styles.module.scss"

const TextArea = ({
  rows = 1,
  id = null,
  name = null,
  value = "",
  placeholder = undefined,
  onChange = () => {},
  onInput = () => {},
  onBlur = () => {},
  disabled = false,
  style = {},
  error,
  options = {},
}) => {
  return (
    <React.Fragment>
      <textarea
        id={id || name}
        className={classNames(styles.textarea, { [styles.error]: !!error })}
        name={name}
        rows={rows}
        onChange={onChange}
        onInput={onInput}
        onBlur={onBlur}
        value={value || ""}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        {...options}
      />

      {error ? <p className={styles["error-message"]}>{error}</p> : null}
    </React.Fragment>
  )
}

export default TextArea
